<template>
  <div>
    <Modal v-model="isShow" width="900" :mask-closable="false">
      <div class="content">
        <div class="header">欢迎您使用创界通平台服务！</div>
        <pre class="kqyxieyi">
创界通平台（以下简称“创界通”）提醒您：在使用创界通网站各项服务前，请您务必仔细阅读并理解本声明。一旦您使用创界通网站即表示您同意遵守本“隐私政策”以及我们的“条款与条件”。

免责事项
创界通及其代理人将尽力维护本网站的安全和功能，但不保证一定能满足用户的所有要求，不保证本网站上所有功能永远正常运作，不保证本网站系统适合您电脑的操作系统或硬件，也不保证网站或其服务器永不产生故障，不被动传播病毒或木马程序及其他有害程序。

主体声明
创界通网站由深圳创界通云科技有限公司合法持有及经营。

隐私政策
创界通尊重和保护创界通网站及与网站相连的创界通地方网站访问者的隐私。为了给您提供更准确、更有个性化的服务，创界通会按照本隐私权政策的规定使用和披露您的个人信息。但创界通将以高度审慎的态度对待这些信息。

访问者信息的使用
我们从您处收集的信息将以下列方式使用：
(a) 创界通不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和创界通单独或共同为您提供服务。
(b) 创界通亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何创界通用户如从事上述活动，一经发现，创界通有权立即终止与该用户的服务协议。
(c) 为服务用户的目的，创界通可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息。

访问者信息的管理
创界通网站及所收集的信息由深圳创界通云科技有限公司管理和控制。

访问者信息的保护
为了保障您访问我们网站时提供的信息，我们已经采取了各种安全措施。您的个人信息处于各种安全网络的保护，只有少数拥有特殊访问权限的人士才能访问该信息，而且我们要求他们对信息保密。

对于您提供的个人信息，我们将根据中华人民共和国相关法律进行保密并严格保管，我们不会违反规定将这些信息转售或转租给任何第三方，但下述情况除外：
(一) 当司法机关或行政机关依照法定程序和法定职权要求本网站披露个人资料时，我们将依法提供相关资料。对于此情况下的任何披露，本网站均得免责；
(二) 对于任何由黑客攻击、计算机病毒侵入或发作、或政府管制而造成的暂时性关闭等影响网站正常运营的不可抗力事件所造成的个人资料的泄露、丢失、被盗用或被篡改等，本网站均得免责；
(三) 对于用户将个人密码告知他人或与他人共享注册帐号所导致的任何个人资料泄露，丢失、被盗用或被篡改等,本网站不负任何责任；
(四) 对于与本网站链接的任何其它网站的个人资料泄露，丢失、被盗用或被篡改等事件，本网站不负任何责任。
但请您注意，无论何时，当您在线提供个人信息时，始终存在信息被第三方截获和使用的风险。尽管 创界通 会尽力保护您的个人信息及隐私安全，但我们无法确保您在线公开的任何信息的绝对安全，因此您需要自行承担由此引起的一切风险。

第三方
向第三方公开个人信息
除了针对创界通用于上述目的之外，并且除下述情况以外，我们在事先通知您之前并遵照资料隐私法的规定，不会出售、交换或以其它方式将您的个人信息转移给第三方。深圳创界通云科技有限公司都非常重视您个人信息的隐私和保护，并制订了类似的隐私政策。您的资料可能被转移至网站主机托管合作伙伴及其它帮助我们设计和运行网站、执行服务（如处理奖品）或帮助我们分析资料的机构。这些机构只将您的资料用于开展指定工作目的，并被要求对信息保密。如果法律要求，我们也会公开个人资料。

与第三方的链接
为您方便起见，也为了提高网站的使用率，我们在网站中插入了与第三方的链接，但本隐私政策对此并不适用。这些链接将您带出我们的服务之外，并离开创界通站点，将超出我们的控制范围。这包括依照品牌共享协议可以使用创界通标识的合作伙伴的链接。您可以链接访问的站点都拥有各自独立的隐私政策。尽管我们设法维护我们网站的完整性，创界通不负责这些站点中的内容和活动，因此无法对其承担责任。因此您需自行承担访问/接入这些站点的全部风险。请注意：这些站点可能会向用户发送它们自己的cookie来收集资料或索取个人信息。

cookies 的使用
cookie是您所访问的网站传送到您的计算机的一个小型信息串，用于验证身份。Cookies 可用于跟踪您在该网站的活动，并且可以帮助我们了解您的喜好，使我们能够改善您的网站体验。Cookies 也可用来记住像用户名和密码之类的信息。
如果您不希望接收 cookie，您也可以将它们关闭。您还可以将计算机设置为在接收cookies 时提醒您。对这两种选择，您都需要调整浏览器（如 internet explorer）的设置。您还可以使用某些软件产品来为您管理 cookies。请注意：如果您将您的计算机设置为拒绝 cookies，它可能会对您所访问网站的功能加以限制，从而有可能无法使用该网站的某些功能。

未成年人的隐私
未成年人应在家长及监护人陪同下一起上网，并参加 World Wide Web（WWW）提供的各种网站上的活动。当未成年人尝试提交他/她的注册时，他/她将需要接受信息收集、信息使用中所述的同类信息。

隐私政策的修改
由于法律法规的变更，以及为了与互联网的新发展和可能的发展趋势保持同步，我们可能会不定时修改本政策。因此，我们保留自行决定实施此类修改的权利，并要求您定期查阅本页内容，因为当您访问我们网站时将受此类修改的约束。

在线政策
本隐私政策不能影响互联网运行中本身已经存在的任何内容，所以这些内容将超出创界通的控制范围，因此本政策不得以任何违背适用法律或政府法规的方式适用于这些内容。本在线隐私政策仅适用于通过我们网站收集的信息，对离线收集的信息不适用。

内容所有权
本网站显示的所有内容，包括但不限于文字、图表、照片、图像、动画、音效、插图及软件等（简称内容），均属深圳创界通云科技有限公司所有。本网站内的所有组成要素，包括但不限于整体设计及内容，均受商业外观、版权、道德规范、商标及其它所有相关知识产权的法律保护。除非依据本条款 与条件或与经深圳创界通云科技有限公司在其它协议的声明同意外，本网站內的任何部分或组成要素或“內容”均不得以任何方式复制或传播，网站中的“內容”及一切相关权利将为深圳创界通云科技有限公司或其许可人的资产。

版权
除网站内的特定文件规定之外，您可以出于私人目的、获取信息及非商业性的目的查看、播放、打印和下载网站内的文件、音频和视频信息。但是不得对任何材料进行修改，也不可自行复印、分发、传递、展示、执行、复制、发布、授权、转移或出售任何内容，以及制作内容的衍生品
</pre>
      </div>

      <div slot="footer" class="footer">
        <Button type="primary" @click="close(false)">知道了</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: ['agreementType'],
  data() {
    return {
      isShow: true,
    };
  },
  watch: {
    isShow(val) {
      this.close(val);
    },
  },
  methods: {
    close(val) {
      this.$emit('changeState', val);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ivu-modal-header {
  display: none;
}
.header {
  font-weight: 700;
  color: #333;
  font-size: 18px;
  margin-bottom: 20px;
}
.footer {
  text-align: center;
  padding-bottom: 40px;
}
.content {
  padding: 0 30px;
  line-height: 26px;
  color: #333;
  h3 {
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
  }
}
/deep/ .ivu-modal-content {
  height: 770px;
  overflow: auto;
}
/deep/ .ivu-modal-close {
  display: none;
}
.kqyxieyi {
  max-width: 852px;
  white-space: pre-wrap;  
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/sureOrder/components/userAgreement51.vue